import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { createPublicClientFromNetworkData } from '../viem/createPublicClientFromNetworkData';
export { createWalletClientForWalletAccount } from '../viem/createWalletClientForWalletAccount';
export { mapNetworkDataToViemChain } from '../viem/utils/mapNetworkDataToViemChain';
